import {css} from '@emotion/react';

export const modal = css`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.4);

    .ModalContent {
        
        background-color: #fefefe;
        margin: 35vh auto;
        padding: 20px;
        border: 0;
        width: 20%;
        height: auto;
        border-radius: 0.8rem;
        overflow: hidden;

        .ContainerClose {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 10px;

            &:hover {
                cursor: pointer;
                opacity: 0.8;
                transition: opacity 0.2s ease-in-out;

            }
        }

        .Title {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 10px;
            text-align: center;
        }

        .Content {
            margin-bottom: 10px;
            text-align: center;
        }
        
    }
`;